import { Card, CardBody, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";

export default function MultipleChoice(props) {
  var studentAnswer = props.data.studentAnswer.split("[,]");
  var correctAnswer = props.data.correctAnswer.split("[,]");

  return (
    <Card className="h-100 mb-0">
      <CardBody>
        <Row>
          <Col style={{ flex: "0 0 50%" }}>
            <span className="fw-bold">
              <FormattedMessage id="CorrectAnswer" />
            </span>
            {correctAnswer.map((answer, index) => {
              return (
                <div key={"qa" + props.questionIndex + "ca" + index}>
                  {answer}&nbsp;
                  <br />
                </div>
              );
            })}
          </Col>
          <Col style={{ flex: "0 0 50%" }}>
            <span className="fw-bold">
              <FormattedMessage id="StudentsAnswer" />
            </span>
            {studentAnswer.map((answer, index) => {
              return (
                <div key={"qa" + props.questionIndex + "sa" + index}>
                  {answer}&nbsp;
                  <br />
                </div>
              );
            })}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
